import { components } from "@/lib/ApiSchema";
import { useEffect, useRef } from "react";

export default function useScrollToBottomOnAppendOperation(
  listData: components["schemas"]["OperationDetailSchema"][],
) {
  const listContainerRef = useRef<HTMLDivElement>(null);
  const listDataRef =
    useRef<components["schemas"]["OperationDetailSchema"][]>(listData);

  useEffect(() => {
    if (
      listDataRef.current.length > 0 &&
      listDataRef.current.length < listData.length &&
      listDataRef.current[listDataRef.current.length - 1].id !==
        listData[listData.length - 1].id
    ) {
      listContainerRef.current?.lastElementChild?.scrollIntoView();
      listDataRef.current = listData;
    }
  }, [listData]);

  return listContainerRef;
}
